/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.ItemListRender = (function () {

    function ItemListRender (item) {

        this.createBaseStructure = function () {
            this.rootEl = document.createElement('div');
            this.rootEl.className = 'panelItem';
        };

        this.createItem = function () {
            var icon = document.createElement('div');
            var name = document.createElement('div');

            icon.className = item.rootEntity.key;
            name.className = 'name';
            name.innerHTML = item.name;
            name.setAttribute('title', item.name);

            name.prepend(icon);
            this.rootEl.appendChild(name);

        };

        this.addEventListeners = function (buttons) {

            if (buttons.open) {
                buttons.open.addEventListener('click', function () {
                    App.Objects.PanelBuilder.show(item);
                });
            }

            if (buttons.remove) {
                buttons.remove.addEventListener('click', function () {
                    const deleteAction = () => {
                        App.Objects.PanelBuilder.delete(item);
                    };

                    new Greenmile.Components.AlertModal('Greenmile.Survey.Confirm.DeleteItem',
                        null,
                        deleteAction
                    )
                    .show();
                    
                });
            }

            if (buttons.edit) {
                buttons.edit.addEventListener('click', function () {
                    App.Objects.PanelBuilder.edit(item);
                });
            }

            if (buttons.clone) {
                buttons.clone.addEventListener('click', function () {
                    App.Objects.PanelBuilder.clone(item);
                });
            }
        };

        this.addButtons = function () {
            
            var buttons = {};
            var buttonsContainer = document.createElement('div');
            buttonsContainer.className = 'buttonsContainer';

            if (Greenmile.PanelBuilder.Utils.checkPermissions('PANEL_VIEW')) {
                var open = document.createElement('div');
                open.className = 'button open';
                open.setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.open'));
                buttonsContainer.appendChild(open);
                buttons = {
                    ...buttons,
                    open
                };
            }
            
            if (Greenmile.PanelBuilder.Utils.checkPermissions('PANEL_BUILD')) {
                var edit = document.createElement('div');
                edit.className = 'button edit';
                edit.setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.edit'));
                buttonsContainer.appendChild(edit);
                buttons = { 
                    ...buttons,
                    edit
                };
            }
            
            if (Greenmile.PanelBuilder.Utils.checkPermissions('PANEL_REMOVE')) {
                var remove = document.createElement('div');
                remove.className = 'button remove';
                remove.setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.remove'));
                buttonsContainer.appendChild(remove);
                buttons = {
                    ...buttons,
                    remove
                };
            }
            
            var clone = document.createElement('div');
            clone.className = 'button clone';
            clone.setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.clone'));
            buttonsContainer.appendChild(clone);
            buttons = {
                ...buttons,
                clone
            };

            this.addEventListeners(buttons);


            this.rootEl.appendChild(buttonsContainer);

        };

        this.render = function () {
            this.createBaseStructure();
            this.createItem();
            this.addButtons();

            return this.rootEl;

        };

        return this.render();
    }

    return ItemListRender;

}());